(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./packages/hooks/src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./packages/hooks/src/index.ts":
/*!*************************************!*\
  !*** ./packages/hooks/src/index.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(__webpack_require__(/*! ./useOutsideReacter */ "./packages/hooks/src/useOutsideReacter.tsx"), exports);
__exportStar(__webpack_require__(/*! ./useScrollLock */ "./packages/hooks/src/useScrollLock.ts"), exports);
__exportStar(__webpack_require__(/*! ./useArrowNavigation */ "./packages/hooks/src/useArrowNavigation.tsx"), exports);
__exportStar(__webpack_require__(/*! ./useIntersectionObserver */ "./packages/hooks/src/useIntersectionObserver.ts"), exports);
__exportStar(__webpack_require__(/*! ./useIsBreakpoint */ "./packages/hooks/src/useIsBreakpoint.ts"), exports);
__exportStar(__webpack_require__(/*! ./useIsomorphicLayoutEffect */ "./packages/hooks/src/useIsomorphicLayoutEffect.ts"), exports);


/***/ }),

/***/ "./packages/hooks/src/useArrowNavigation.tsx":
/*!***************************************************!*\
  !*** ./packages/hooks/src/useArrowNavigation.tsx ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useArrowNavigation = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
var useArrowNavigation = function (_a) {
    var listItems = _a.listItems, onArrowUpOrDown = _a.onArrowUpOrDown;
    var _b = (0, react_1.useState)(0), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var setSelectedIndexWithUseCallback = (0, react_1.useCallback)(function (index) {
        setSelectedIndex(index);
    }, [listItems]);
    var handleUpArrow = function () {
        if (selectedIndex > 0) {
            setSelectedIndexWithUseCallback(selectedIndex - 1);
        }
        else {
            setSelectedIndexWithUseCallback(listItems.length - 1);
        }
    };
    var handleDownArrow = function () {
        if (selectedIndex < listItems.length - 1) {
            setSelectedIndexWithUseCallback(selectedIndex + 1);
        }
        else {
            setSelectedIndexWithUseCallback(0);
        }
    };
    var handleKeyDown = function (keyboardEvent) {
        var key = keyboardEvent.key;
        if (listItems === null || listItems === void 0 ? void 0 : listItems.length) {
            if (key === 'ArrowUp') {
                onArrowUpOrDown && onArrowUpOrDown();
                keyboardEvent.preventDefault();
                handleUpArrow();
            }
            else if (key === 'ArrowDown') {
                onArrowUpOrDown && onArrowUpOrDown();
                keyboardEvent.preventDefault();
                handleDownArrow();
            }
            else {
                return;
            }
        }
        else {
            return;
        }
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('keydown', handleKeyDown);
        return function () { return window.removeEventListener('keydown', handleKeyDown); };
    });
    (0, react_1.useEffect)(function () {
        setSelectedIndexWithUseCallback(0);
    }, [listItems]);
    return { selectedIndex: selectedIndex };
};
exports.useArrowNavigation = useArrowNavigation;


/***/ }),

/***/ "./packages/hooks/src/useIntersectionObserver.ts":
/*!*******************************************************!*\
  !*** ./packages/hooks/src/useIntersectionObserver.ts ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersectionObserver = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
var useIntersectionObserver = function (options) {
    var containerRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(false), isVisible = _a[0], setIsVisible = _a[1];
    var handleIntersection = function (entries) {
        var entry = entries[0];
        setIsVisible(entry.isIntersecting);
    };
    (0, react_1.useEffect)(function () {
        if (window && window.IntersectionObserver) {
            var observer_1 = new IntersectionObserver(handleIntersection, options);
            var element_1 = containerRef.current;
            if (containerRef.current) {
                observer_1.observe(containerRef.current);
            }
            return function () {
                if (element_1) {
                    observer_1.unobserve(element_1);
                }
            };
        }
        else {
            setIsVisible(false);
        }
    }, [containerRef, options]);
    return { containerRef: containerRef, isVisible: isVisible };
};
exports.useIntersectionObserver = useIntersectionObserver;
exports.default = exports.useIntersectionObserver;


/***/ }),

/***/ "./packages/hooks/src/useIsBreakpoint.ts":
/*!***********************************************!*\
  !*** ./packages/hooks/src/useIsBreakpoint.ts ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsBreakpoint = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
var breakpoints = {
    xs: 1,
    mobileSmall: 320,
    mobile: 375,
    tablet: 768,
    tabletLarge: 920,
    desktopSmall: 1024,
    desktop: 1260,
    desktopLarge: 1440
};
var useIsBreakpoint = function (breakpoint) {
    var _a = (0, react_1.useState)(null), screenWidth = _a[0], setScreenWidth = _a[1];
    var handleResize = (0, react_1.useCallback)(function () {
        setScreenWidth(window.innerWidth);
    }, []);
    (0, react_1.useEffect)(function () {
        handleResize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(function () {
        window.addEventListener('resize', handleResize, { passive: true });
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [handleResize, screenWidth]);
    return screenWidth >= breakpoints[breakpoint];
};
exports.useIsBreakpoint = useIsBreakpoint;
exports.default = exports.useIsBreakpoint;


/***/ }),

/***/ "./packages/hooks/src/useIsomorphicLayoutEffect.ts":
/*!*********************************************************!*\
  !*** ./packages/hooks/src/useIsomorphicLayoutEffect.ts ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicLayoutEffect = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
exports.useIsomorphicLayoutEffect = typeof window !== 'undefined' ? react_1.useLayoutEffect : react_1.useEffect;
exports.default = exports.useIsomorphicLayoutEffect;


/***/ }),

/***/ "./packages/hooks/src/useOutsideReacter.tsx":
/*!**************************************************!*\
  !*** ./packages/hooks/src/useOutsideReacter.tsx ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutsideReacter = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
/**
 * Calls reacterFunction if the user clicks outside the element that has ref as a reference.
 */
function useOutsideReacter(ref, reacterFunction) {
    function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            reacterFunction();
        }
    }
    (0, react_1.useEffect)(function () {
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    });
}
exports.useOutsideReacter = useOutsideReacter;


/***/ }),

/***/ "./packages/hooks/src/useScrollLock.ts":
/*!*********************************************!*\
  !*** ./packages/hooks/src/useScrollLock.ts ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollLock = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
// Disable body scrolling when overlay is visible.
// Practical in conjunction with e.g. react-modal:
// https://github.com/reactjs/react-modal/issues/191
var useScrollLock = function () {
    var lock = (0, react_1.useCallback)(function () {
        var scrollY = window.scrollY + "px";
        var body = document.body;
        body.style.position = 'fixed';
        body.style.top = "-" + scrollY;
    }, []);
    var unlock = (0, react_1.useCallback)(function () {
        var body = document.body;
        var scrollY = body.style.top;
        var parsedScrollY = parseInt(scrollY || '0') * -1;
        body.style.position = '';
        body.style.top = '';
        if (parsedScrollY) {
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    }, []);
    return { lock: lock, unlock: unlock };
};
exports.useScrollLock = useScrollLock;


/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
});
//# sourceMappingURL=index.js.map